import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import {
  initAnalytics,
  installAutoCapture,
  installEngagementTracking,
  installErrorTracking,
  trackPageView,
} from './lib/analytics'
import { API_BASE } from './lib/api'
import { installViewAs } from './lib/viewAs'
import { retryPendingStop } from './components/shell/stopImpersonating'
import { initTheme } from './theme/theme'
import './theme/tokens.css'
import './styles.css'

// Before anything can make a request: every request this tab makes carries
// its "View as" grant, if it has one (lib/viewAs).
installViewAs(API_BASE)
// A stop the server never recorded (offline, a 500) is sent again: the
// server's stop is what revokes the grant.
void retryPendingStop()

// Before React renders: the attribute has to exist on <html> for the first
// paint, or the page flashes the wrong theme.
initTheme()

// The first Page View belongs here, not in the router: pre-auth pages
// (/login and friends) render without a router at all, and this is the one
// place every full document load passes through. In-app route changes are
// PageViewTracker's job (App.tsx), which skips its initial location so the
// two never double-count.
initAnalytics()
installErrorTracking()
installAutoCapture()
installEngagementTracking()
trackPageView()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
